import styled from 'styled-components';
import { COLORS } from 'styles/variables';

export const UpperNoteWrapper = styled.div`
  position: relative;

  .decoration-image {
    position: absolute;
    width: 50rem;
    top: -6rem;
    right: 23rem;
  }

  .bold {
    font-weight: bold;
  }

  .fee-detail {
    background-color: white;
    max-width: fit-content;
    outline: 1.5rem solid white;
    margin: 3rem 0;
    border-radius: 10px;
    padding: 0.1rem;

    span {
      &.text-red {
        color: ${COLORS.RED};
      }

      &.text-blue {
        color: ${COLORS.BLUE_1};
      }
    }
  }
  }
`;

export const TextDecoration = styled.span`
  position: relative;

  .decoration {
    position: absolute;
    width: 20rem;
    right: 50%;
    transform: translateX(50%);
  }
`;
